
define('text!modules/vendor/templates/box_list_item.html',[],function () { return '<dd class="item clearfix" data-id="{{id}}">\n    <div>{{name}}</div>\n    <div class="remove"></div>\n</dd>';});

